export default __webpack_public_path__ + "static/media/edu.b4221683.png";